<template>
  <div class="row mt-4">
    <div class="col-12">
      <h1 class="title text-uppercase font-weight-bold">Produtos para editar lojista</h1>
    </div>

    <div class="col-2 mt-4">
      <label>Lojista ID:</label>
      <input type="text" v-model="lojista_id" class="form-control" placeholder="####">
    </div>

    <div class="col-10 d-flex justify-content-left align-items-end">
      <button class="btn btn-primary" @click="buscarProdutos()">Buscar</button>
    </div>

    <div class="col-12 mt-2">
      <table class="table table-striped table-bordered">
        <thead class="letter-orange">
            <th>Produto</th>
            <th class="text-center">Cod. barras</th>
            <th class="text-center">Marca</th>
            <th class="text-center">Unidade</th>
            <th class="text-center">Peso (Kg)</th>
            <th class="text-center">Altura (Cm)</th>
            <th class="text-center">Largura (Cm)</th>
            <th class="text-center">Comprimento (Cm)</th>
            <th class="text-center">Lojista ID</th>
            <th class="text-center" style="width: 170px">Ações</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.produto }}</td>
            <td class="text-center">{{ item.codbar }}</td>
            <td class="text-center">{{ item.marca }}</td>
            <td class="text-center">{{ item.unidade }}</td>
            <td class="text-center">{{ item.peso }}</td>
            <td class="text-center">{{ item.altura }}</td>
            <td class="text-center">{{ item.largura }}</td>
            <td class="text-center">{{ item.comprimento }}</td>
            <td class="text-center">
              <span class="cursor-pointer" @click="buscarNomeLojista(item.lojista_id)">
                {{ item.lojista_id }}
              </span>
            </td>
            <td class="text-center">
              <span
                class="btn btn-info btn-sm mr-2"
                @click="novoStatus(item.id, 4)"
                v-b-tooltip.hover
                title="Liberar para todos os lojistas"
              >
                <i class="fas fa-users"></i>
              </span>

              <span
                class="btn btn-primary btn-sm mr-2"
                @click="visualizar(item)"
                v-b-tooltip.hover
                title="Ver o produto"
              >
                <i class="fas fa-eye"></i>
              </span>

              <span
                class="btn btn-danger btn-sm mr-2"
                @click="removerLista(item.id, index)"
                v-b-tooltip.hover
                title="Remover da lista"
              >
                <i class="fas fa-trash"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
      ></b-pagination>
    </div>

    <b-modal
      title="Foto do produto"
      size="xl"
      id="modalImagem"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <b-row>
        <b-col cols="12">
          <img :src="urlImagem" style="width: 100%;">
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      title="Detalhes do produto"
      size="xl"
      id="modalProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="9" class="mb-2">
          <label>Nome do produto </label>
          <input type="text" class="form-control" v-model="dataProduct.produto" disabled>
        </b-col>

        <b-col cols="3" class="mb-2">
          <label>Código de barra </label>
          <input type="text" class="form-control" v-model="dataProduct.codbar" disabled>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Marca</label>
          <input type="text" class="form-control" v-model="dataProduct.marca" disabled>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Unidade de medida</label>
          <input type="text" class="form-control" v-model="dataProduct.unidade" disabled>
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Peso (Kg)</label>
          <input type="text" class="form-control" v-model="dataProduct.peso" disabled v-money="formatTipo">
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Altura (Cm)</label>
          <input type="text" class="form-control" v-model="dataProduct.altura" disabled v-money="formatTipo">
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Largura (Cm)</label>
          <input type="text" class="form-control" v-model="dataProduct.largura" disabled v-money="formatTipo">
        </b-col>

        <b-col cols="2" class="mb-2">
          <label>Comprimento (Cm)</label>
          <input type="text" class="form-control" v-model="dataProduct.comprimento" disabled v-money="formatTipo">
        </b-col>

        <b-col cols="12" class="mb-2">
          <label>Descrição do produto</label>
          <textarea class="form-control" rows="3" disabled v-model="dataProduct.descricao"></textarea>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
          <label>Categoria: </label>
          <span class="ml-2"><b>{{categoria}}</b></span>

          <select class="custom-select mb-3" @change="selectId()" v-model="categoriaSelect" v-show="validLink == false">
            <option selected value="">-- Selecione a categoria {{count+1}} --</option>
            <option v-for="(item, i) in categorias" :key="i" :value="item">{{item.nome_departamento}}</option>
          </select>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Ficha(s) tec.</label>

          <table class="table table-striped table-bordered mt-2">
            <thead>
              <tr>
                <th scope="col">Tipo</th>
                <th scope="col">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in dataProduct.produto_fichas" :key="i" v-show="item.tipo != null">
                <td>{{item.tipo}}</td>
                <td>{{item.descricao}}</td>
              </tr>
              <tr v-if="dataProduct.produto_fichas && dataProduct.produto_fichas.length == 0">
                <td colspan="3">
                  <span>Sem ficha tec. cadastrada!</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="6" class="mt-2">
          <label>Fotos</label>
          <b-row>
            <b-col cols="2" class="mt-2 mr-2 text-center" v-for="(item, i) in dataProduct.produto_fotos" :key="i">
              <img 
                :src="formatUrl(item.foto_png ? item.foto_png : item)"
                :alt="dataProduct.produto+' - '+i"
                @click="openImg(formatUrl(item.foto_png ? item.foto_png : item))"
                width="70" 
                class="cursor-pointer"
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
export default {
  mixins: [makeToast],
  
  name: 'ProdutosEditarLojista',
  data() {
    return {
      data: [],
      urlImagem: '',
      categoriaSelect: '',
      categoria: '',
      categorias: [],
      count: 0,
      tipo: null,
      corbar: null,
      validLink: true,
      descricao: null,
      lojista_id: null,
      valid: false,
      dataProduct: {
        produto: null,
        codbar: null,
        marca: null,
        uni_med: null,
        peso: null,
        altura: null,
        largura: null,
        comprimento: null,
        departamento_id: null,
        lojista_id: null,
        aprovar: false,
        produto_fichas: [],
        produto_fichas_remover: [],
        produto_fotos: [],
        produto_fotos_remover: []
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      formatTipo: {
        decimal: '.',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true
      },
    };
  },


  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  watch: {
    'pagination.currentPage': function () {
      this.buscarProdutos();
    },
  },

  created() {
    this.buscarProdutos();
  },

  methods: {
    openImg(url) {
      this.urlImagem = url;
      this.$bvModal.show('modalImagem');
    },
    visualizar(item) {
      this.dataProduct = item;
      this.corbar = item.codbar;
      this.categoria = item.departamento;
      this.validLink = true;

      this.$bvModal.show('modalProduto');
    },
    buscarProdutos() {
      const path = {
        currentPage: this.pagination.currentPage,
        id: this.lojista_id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarProdutoEditarLojista', path)
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 50;
          this.pagination.total = total || 0;

          this.data =  data || [];
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    removerLista(id, i) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/removerProdutoLista', id)
        .then(() => {
          this.data.splice(i, 1);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    novoStatus(id, status) {

      var params = {
        id: id,
        status: status
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoUpStatus', params)
        .then(() => {
          this.buscarProdutos();

          this.makeToast('Sucesso!', 'Status atualizado!', 'success');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
    buscarNomeLojista(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/nomeLojista', id)
        .then((response) => {
          if(response.data.nome_fantasia) {
            this.makeToast(
              response.data.nome_fantasia+ ' - CNPJ:'+response.data.cnpj, 
              'Endereço:'+response.data.endereco+', '+response.data.nome+'-'+response.data.uf, 
              'success',
              'b-toaster-top-right',
              10000
            );
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
  },
}
</script>
